import isNil from "lodash/isNil";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLoanFilesHook } from "../../../../hooks/useLoanFilesHook";
import { pipelineSetKey } from "../../../../redux/reducers/pipelineReducer";
import LoanSizerFilesTable from "../../../../shared/tables/LoanSizerFilesTable/LoanSizerFilesTable";
import { RouteTableScreen } from "../components/RouteTableScreen";
import { REDUX_PIPELINE_KEYS } from "../../../../constants/keyNames/reduxPipeline";

const UploadedSizersRoute = () => {
  const keyName = REDUX_PIPELINE_KEYS.UPLOADED_SIZERS;
  const pipeline = useSelector((state) => state.pipeline?.[keyName]);
  const { getAllSizerUploads } = useLoanFilesHook();
  const dispatch = useDispatch();

  useEffect(() => {
    if (isNil(pipeline)) {
      getAllSizerUploads({
        onSuccessFn: (data) => {
          dispatch(pipelineSetKey(keyName, data));

          console.log("Fetched all sizer uploads:", data);
        },
        onErrorFn: (error) => {
          console.error("Error fetching sizer uploads:", error);
        },
      });
    }
  }, []);
  return (
    <RouteTableScreen rowData={pipeline}>
      <LoanSizerFilesTable />
    </RouteTableScreen>
  );
};

export default UploadedSizersRoute;
